export const recordPaymentMethods = ["CC", "ACH", "profilePayment"];
export const onlinePaymentMethods = ["online", "profilePayment"];
export const allPaymentMethods = ["CC", "ACH", "skipPayment", "profilePayment"];

export const navigatingAwayApplicationDetailAlertMessage =
  "You are navigating away from this page without submitting your application. All saved information will be retained and you may return to continue the application. Do you want to continue?";
